import { render, staticRenderFns } from "./ListadoSolicitudTransferenciaRecursos.vue?vue&type=template&id=2295ff2a"
import script from "./ListadoSolicitudTransferenciaRecursos.vue?vue&type=script&lang=js"
export * from "./ListadoSolicitudTransferenciaRecursos.vue?vue&type=script&lang=js"
import style0 from "./ListadoSolicitudTransferenciaRecursos.vue?vue&type=style&index=0&id=2295ff2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports